import { useState } from 'react'
import { Link } from 'react-router'
import { submitEnquiry } from '~/enquiryService'

export default function ContactPage() {
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    const form = e.target
    setSubmitting(true)
    setError('')
    try {
      await submitEnquiry({
        name: form.elements['name'].value,
        company: form.elements['company'].value,
        email: form.elements['email'].value,
        phone: form.elements['phone'].value,
        service: form.elements['service'].value,
        message: form.elements['message'].value,
      })
      setSubmitted(true)
    } catch (err) {
      console.error(err)
      setError('Something went wrong. Please try again or call us directly.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <main>
      {/* Hero */}
      <section className="page-hero section-pad muted">
        <div className="container">
          <span className="eyebrow">Get in Touch</span>
          <h1 className="page-hero-title">Contact S.J.S. Technology</h1>
          <p className="page-hero-desc">
            Visit our Bengaluru showroom for a live demo, or send us your
            requirements and we will get back within 24 hours.
          </p>
        </div>
      </section>

      {/* Contact info + Form */}
      <section className="section-pad">
        <div className="container contact-layout">
          {/* Left — contact details */}
          <div className="contact-details">
            <div className="contact-detail-card">
              <div className="contact-detail-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </div>
              <div>
                <h3>Visit Us</h3>
                <p>
                  #17, Ground Floor, G.B. Lane, 1st Cross,<br />
                  Near Dr. T.C.M. Royan Road, Cottonpete,<br />
                  Bengaluru - 560 053, Karnataka, India
                </p>
              </div>
            </div>

            <div className="contact-detail-card">
              <div className="contact-detail-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </div>
              <div>
                <h3>Call Us</h3>
                <p>
                  <a href="tel:+918884990111">+91 88849 90111</a><br />
                  <a href="tel:+918042122155">+91 80 4212 2155</a>
                </p>
              </div>
            </div>

            <div className="contact-detail-card">
              <div className="contact-detail-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </div>
              <div>
                <h3>Email</h3>
                <p>
                  <a href="mailto:contact@sjstechnology.in">contact@sjstechnology.in</a>
                </p>
              </div>
            </div>

            <div className="contact-detail-card">
              <div className="contact-detail-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
              </div>
              <div>
                <h3>Working Hours</h3>
                <p>
                  Mon – Sat: 9:30 AM – 7:00 PM<br />
                  Sunday: Closed
                </p>
              </div>
            </div>
          </div>

          {/* Right — enquiry form */}
          <div className="contact-form-card">
            <h2 className="contact-form-title">Send us a message</h2>
            <p className="contact-form-desc">Fill out the form and our team will get back to you within 24 hours.</p>

            {submitted ? (
              <div className="review-submitted">
                <p>Thank you! Your message has been sent. We will get back to you soon.</p>
              </div>
            ) : (
              <>
                {error && <div className="admin-alert admin-alert-error" style={{ marginBottom: 16 }}>{error}</div>}
                <form className="enquiry-form" onSubmit={handleSubmit}>
                  <div className="enquiry-row">
                    <input name="name" placeholder="Full Name *" required />
                    <input name="company" placeholder="Company Name" />
                  </div>
                  <div className="enquiry-row">
                    <input name="email" type="email" placeholder="Email *" required />
                    <input name="phone" type="tel" placeholder="Phone Number" />
                  </div>
                  <select name="service" defaultValue="" aria-label="Service type">
                    <option value="" disabled>What are you looking for?</option>
                    <option>Digital Printing Machine</option>
                    <option>VisionJet Inks & Consumables</option>
                    <option>Spare Parts</option>
                    <option>Installation & Training</option>
                    <option>Annual Maintenance Contract</option>
                    <option>Other</option>
                  </select>
                  <textarea name="message" placeholder="Describe your requirement…" rows={4} />
                  <button className="btn" type="submit" disabled={submitting} style={{ alignSelf: 'center' }}>
                    {submitting ? 'Sending…' : 'Send Message'}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </section>

      {/* Map */}
      <section className="contact-map">
        <iframe
          title="S.J.S Technology Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.0!2d77.5661336!3d12.9709411!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae17006e7b1997%3A0xd733de19f5c8c033!2sSJS%20Technology!5e0!3m2!1sen!2sin!4v1"
          width="100%"
          height="400"
          style={{ border: 0, display: 'block' }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </section>

      {/* CTA */}
      <section className="section-pad cta">
        <div className="container cta-box cta-box-split">
          <div>
            <span className="eyebrow">Book a live demo</span>
            <h2>See VICTORY machines in action</h2>
            <p>
              Visit our Bengaluru showroom or request an online demo. Share your
              printing needs and we will recommend the perfect setup.
            </p>
          </div>
          <div className="cta-actions">
            <a className="btn" href="tel:+918884990111">Call Now</a>
            <Link className="btn btn-ghost" to="/products">View Products</Link>
          </div>
        </div>
      </section>
    </main>
  )
}
